export default {
  nav: {
    title: 'Uploadable',
  }
}
